import { SxProps } from '@mui/material';
import { grey10 } from 'app/components/ThemeProvider/colors';

export const inputBox: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  width: '320px',

  '& .Mui-disabled': {
    background: grey10,
  },

  '@media screen and (max-width: 1100px)': {
    width: '100%',
  },
};

export const inputOutlined = (isValid: boolean) => {
  return {
    fontSize: '16px',
    fontWeight: 400,
    borderWidth: '1px',
    borderRadius: '8px',
    height: '48px',
    lineHeight: 1,
  };
};
